module.exports = __webpack_public_path__ + "media/unipod/icon-plumbing-1-white-6a915d80.svg";